import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

import { theme } from '@garnish/constants';

import { SIDE_PADDING } from '../../upsell.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellConfirmationContainer = ({
  children,
  style,
}: UpsellConfirmationContainerProps) => {
  return <View style={[styles.container, style]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    borderTopLeftRadius: theme.radius.xxlarge,
    borderBottomLeftRadius: theme.radius.xxlarge,
    backgroundColor: theme.colors.WHITE,
    paddingHorizontal: SIDE_PADDING,
    paddingTop: theme.spacing['10'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type UpsellConfirmationContainerProps = PropsWithChildren<{
  style?: ViewStyle;
}>;
